import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { ConfirmModel } from './confirm-dialog.model';
import { locale as english } from './i18n/en';
import { locale as vietnam } from './i18n/vn';

@Component({
  selector: 'fuse-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class FuseConfirmDialogComponent implements OnInit {
  data: ConfirmModel;

  constructor(
    public dialogRef: MatDialogRef<FuseConfirmDialogComponent>,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this._fuseTranslationLoaderService.loadTranslations(english, vietnam);
  }

  ngOnInit(): void {
    // 310px width per design
    this.dialogRef.updateSize(this.data.modalWidth || '310px');
  }
}
